require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yarrabend-where-nature-meets-the-city.json") })
        }
      }, "path---news-yarrabend-where-nature-meets-the-city");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yarrabend-where-nature-meets-the-city!./.cache/json/news-yarrabend-where-nature-meets-the-city.json
// module id = 874
// module chunks = 231608221292675